export var ThemeOptions;
(function(ThemeOptions) {
    ThemeOptions["DARK"] = 'dark';
    ThemeOptions["LIGHT"] = 'light';
})(ThemeOptions || (ThemeOptions = {}));
export var ThemeSkin;
(function(ThemeSkin) {
    ThemeSkin["NONE"] = 'none';
    ThemeSkin["GREEN"] = 'light-green';
})(ThemeSkin || (ThemeSkin = {}));
